var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sorry-message-wrapper"},[_c('div',{staticClass:"sorry-message"},[_c('p',[_vm._v(_vm._s(_vm._f("t")("charts.errorMessage.sorryMessage1")))]),_c('p',[_vm._v(_vm._s(_vm._f("t")("charts.errorMessage.sorryMessage2")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }